import ContractDetails from "./ContractDetails";
import Confirm from "./Confirm";

import Premises from "./Premises";
import SignStatus from "./SignStatus";
import Parties from "./Parties";
import Attachments from "./Attachments";
import ExistingDocument from "./ExistingDocument";
import Tax from "./Tax";

// Map of chapterdef KEY: Component
export default {
  PREMISES: Premises,
  PARTIES: Parties,
  EXISTINGDOC: ExistingDocument,
  ATTACHMENTS: Attachments,
  CONTRACT: ContractDetails,

  SIGN_STATUS: SignStatus,
  CONFIRM: Confirm,
  TAX: Tax,
};
